<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button
    mat-icon-button
    (click)="toggleCollapsed.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button
    mat-icon-button
    (click)="toggleMobileNav.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications"
  >
    <img
      src="/assets/images/profile/user-1.jpg"
      class="rounded-circle object-cover icon-35 profile-dd"
      width="35"
    />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height: 347px">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">User Profile</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            src="/assets/images/profile/user-1.jpg"
            class="rounded-circle"
            width="95"
          />
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
              {{ userNombre }} {{ userApellido }}
            </h6>
            <!-- <span class="f-s-14 d-block m-b-4">Designer</span> -->
            <span class="d-flex align-items-center">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{ userEmail }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center"
        style="width: 100%"
      >
        <mat-button-toggle-group
          #group="matButtonToggleGroup"
          [(ngModel)]="options.theme"
          (change)="setDark()"
          class="customizer-button-group gap-16"
          [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
        >
          <mat-button-toggle [value]="'light'">
            <div class="d-flex align-items-center f-w-500">
              <i-tabler
                name="sun-high"
                class="d-flex m-r-8 fill-icon"
              ></i-tabler>
              Light
            </div>
          </mat-button-toggle>
          <mat-button-toggle [value]="'dark'">
            <div class="d-flex align-items-center f-w-500">
              <i-tabler name="moon" class="d-flex m-r-8 fill-icon"></i-tabler>
              Dark
            </div>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="p-y-12 p-x-32">
        <a (click)="signOut()" mat-stroked-button color="primary" class="w-100">Salir</a
        >
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>
